import type { LoginFormProps } from '@components/LoginForm/types';
import type { BillingSubscriptionPriceDetailsFragment } from '@graphql/fragments/billing-subscription/price.graphql';
import { createContext } from 'react';

import type { ProductNames } from './types';

export interface StartSubscriptionArgs {
  priceId: string;
  withTrial?: boolean;
  adjustableSeats?: boolean;
  /** Interval for checkout return URLs; pass when derived from the URL to avoid stale state. */
  billingInterval?: 'year' | 'month';
  /** Promo code derived from the URL; takes precedence over the promo input's form state. */
  promotionalCode?: string;
}

export interface BusinessContext {
  /* tracks the required form state */
  formState: {
    firstName: string;
    lastName: string;
    productInterests: ProductNames[];
    seats: number;
    billingInterval: 'year' | 'month';
    minSeatCount: number;
    promotionalCode: string;
    setFirstName: (value: string) => void;
    setLastName: (value: string) => void;
    setProductInterests: (products: ProductNames[]) => void;
    setSeats: (seats: number) => void;
    setBillingInterval: (interval: 'year' | 'month') => void;
    setPromotionalCode: (code: string) => void;
  };
  checkoutLoading: boolean;
  workspacesLoading: boolean;
  prices: BillingSubscriptionPriceDetailsFragment[];
  pricesLoading: boolean;
  startSubscription: (args: StartSubscriptionArgs) => Promise<boolean>;
  checkStepPrerequisites: (
    step:
      | 'login'
      | 'your-name'
      | 'product-interests'
      | 'start-trial'
      | 'start-subscription'
      | 'setup-workspace',
  ) => void;
  goTo: (pathname: string) => void;
  flags?: {
    showBillingIntervalSelector: boolean;
  };
}

export const BusinessOnboardingContext = createContext<BusinessContext | null>(null);

export const SignUpContext = createContext<LoginFormProps | null>(null);
